import { createApp } from 'vue'
import axios from 'axios'

export const configCsrfToAxios = () => {
  // 設定 CSRF token
  const csrfToken = document.querySelector('meta[name="csrf-token"]')
  if (csrfToken) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken.getAttribute('content')
  }
}

export const initializeInstances = ({ pinia, vueApps, importInitializer }) => {
  document.addEventListener('DOMContentLoaded', () => {
    const templates = document.querySelectorAll('[data-vue]')

    templates.forEach(async (template) => {
      try {
        const vueName = template.dataset.vue
        const initializer = await importInitializer(vueName)

        const app = createApp(initializer.default)
        app.use(pinia)
        app.mount(template, true)

        vueApps.push(app)
      } catch (err) {
        console.error(`❌ Failed to initialize ${template.dataset.vue}:`, err)
      }
    })
  })
}
